import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";
import dayjs from "dayjs";

//CUSTOM COMPONENT
import DatePicker from "../../aGlobalDesign/DatePicker/DatePicker";
import Modal from "../../aGlobalDesign/Modal/Modal";
import Area from "../../aGlobalDesign/Area/Area";
import Loader from "../../aGlobalDesign/Loader/Loader";

import DashboardAgents from "./DashboardAgents";
import DashboardClients from "./DashboardClients";
import Dashboard from "./Dashboard";

// Disable date after today on date picker
const currentDate = new Date();
const tomorrow = new Date(currentDate);
tomorrow.setDate(currentDate.getDate() + 1);
const dateInOneYear = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
const disabledDays = [
    { from: tomorrow, to: dateInOneYear }
];

class DashboardContainer extends React.Component {

    constructor() {
        super();
        this.state = {
            openDialogDateSelector: false,
            dateSelected: {
                // 7 days before today
                "Start date": format(new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0), "yyyy-MM-dd HH:mm:ss").toString(),
                // Today
                "End date": format(new Date(), "yyyy-MM-dd HH:mm:ss").toString()
            },
            range: {
                from: null,
                to: null
            },
            openDialogZoneSelector: null,
            zoneList: null,
            callCenterList: null,
            zoneSelected: null,
            openDialogCallCenterSelector: null,
            callcenterSelected: null,
            results: null,
            openCallsDialog: null,
            selectedPage: "fullview",
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload"),
            reloadKey: 0
        };
    }
    componentDidMount() {
        this.props.toggleDashboardMenu();
        this.setState({
            zoneList: null,
            callCenterList: null,
            zoneSelected: null
        });
        if (!this.props.monitoring.secondarycallcenters) {
            this.props.GetSecondaryCallCentersList((data) => {});
        }

        const accessRight = this.props.currentuser.accessrights ? this.props.currentuser.accessrights.hasPermission(10, "consult") : 0;
        this.props.GetRestrictedZones((data) => {
            if (accessRight < 20 || !data.results || data.results.length <= 0) {
                this.setState({ results: "noZone" });
            }
            else {
                let index = data.results.findIndex(i => i.id === this.props.monitoring.dashboardzoneId);
                if (!index || index < 0) {index = 0;}
                this.setState({
                    zoneList: data.results,
                    zoneSelected: null,
                    callCenterList: null
                });
                this.setState({ reload: this.state.reload - 1 });
            }
        }, accessRight);
    }
    componentDidUpdate(prevProps) {
        const reload = new URLSearchParams(new URL(window.location.href).search).get("reload");
        if (reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
        }
    }

    ConvertDateForDisplay() {
        const startTime = format(new Date(this.state.dateSelected["Start date"]), "dd.MM.yyyy").toString();
        const endTime = format(new Date(this.state.dateSelected["End date"]), "dd.MM.yyyy").toString();
        if (startTime === endTime) {return startTime;}
        else {return startTime + " ‣ " + endTime;}
    }

    render() {
        return <>
            <Area
                helmet={strings.helmetDashboard}
                title={strings.dashboard}
                navigatedId={this.state.selectedPage}
                navigation={[
                    {
                        id: "fullview",
                        title: strings.dashboardFullView,
                        onSelect: () => this.setState(prev => ({
                            selectedPage: "fullview",
                            reloadKey: prev.reloadKey + 1
                        }))
                    },
                    {
                        id: "agentsview",
                        title: strings.dashboardAgents,
                        onSelect: () => this.setState(prev => ({
                            selectedPage: "agentsview",
                            reloadKey: prev.reloadKey + 1
                        }))
                    },
                    {
                        id: "clientsview",
                        title: strings.dashboardClients,
                        onSelect: () => this.setState(prev => ({
                            selectedPage: "clientsview",
                            reloadKey: prev.reloadKey + 1
                        }))
                    }
                ]}
                sideButtons={[
                    {
                        type: "secondary-icon",
                        onClick: () => {
                            this.setState({
                                openDialogDateSelector: true
                            });
                        },
                        nameIcon: "calendar",
                        text: this.ConvertDateForDisplay()
                    },
                    {
                        type: "secondary-icon",
                        disabled: !this.state.zoneList || this.state.zoneList.length <= 0,
                        onClick: () => {
                            this.setState({
                                openDialogZoneSelector: {
                                    id: this.state.zoneSelected && this.state.zoneSelected.id ? this.state.zoneSelected.id : null,
                                    name: this.state.zoneSelected && this.state.zoneSelected.name ? this.state.zoneSelected.name : null,
                                    secondaryList: this.state.zoneSelected && this.state.zoneSelected.secondaryList ? this.state.zoneSelected.secondaryList : null
                                }
                            });
                        },
                        nameIcon: "arrowFrom",
                        text: this.state.zoneSelected ? this.state.zoneSelected.name : strings.AllZones
                    },
                    {
                        type: "secondary-icon",
                        disabled: !this.state.zoneList || this.state.zoneList.length <= 0 || !this.state.zoneSelected,
                        onClick: () => {
                            this.setState({
                                openDialogCallCenterSelector: {
                                    id: this.state.callcenterSelected && this.state.callcenterSelected.id ? this.state.callcenterSelected.id : null,
                                    name: this.state.callcenterSelected && this.state.callcenterSelected.name ? this.state.callcenterSelected.name : null
                                }
                            });
                        },
                        nameIcon: "building",
                        text: this.state.callcenterSelected ? this.state.callcenterSelected.name : strings.allCallCenters
                    }
                ]}>
                <div className="container-area-body">
                    { this.state.zoneList && this.state.results !== "noZone" ? <>
                        { this.state.selectedPage == "fullview" ? <Dashboard
                            reload={this.state.reload}
                            key={`fullview-${this.state.reloadKey}`}
                            dateSelected={this.state.dateSelected}
                            zoneSelected={this.state.zoneSelected}
                            callcenterSelected={this.state.callcenterSelected}
                        /> : null
                        }
                        { this.state.selectedPage == "agentsview" ? <DashboardAgents
                            reload={this.state.reload}
                            key={`agentsview-${this.state.reloadKey}`}
                            dateSelected={this.state.dateSelected}
                            zoneSelected={this.state.zoneSelected}
                            callcenterSelected={this.state.callcenterSelected}
                        /> : null
                        }
                        { this.state.selectedPage == "clientsview" ? <DashboardClients
                            reload={this.state.reload}
                            key={`clientsview-${this.state.reloadKey}`}
                            dateSelected={this.state.dateSelected}
                            zoneSelected={this.state.zoneSelected}
                            callcenterSelected={this.state.callcenterSelected}
                        /> : null
                        }
                    </> : this.state.results == "noZone" ? <div> Aucun dashboard disponible. </div> : <div>
                        <Loader dimensions="40px" color={"var(--primary-base)"} />
                    </div>
                    }
                </div>
            </Area>
            <DatePicker open={this.state.openDialogDateSelector}
                onClose={() => this.setState({ openDialogDateSelector: false })}
                blockFutureDates={true}
                onValidate={(range) => {
                    const start = dayjs(range.startDate);
                    const end = dayjs(range.endDate);

                    const normalizedStart = start.startOf("day").format("YYYY-MM-DD HH:mm:ss");
                    const normalizedEnd = end.endOf("day").format("YYYY-MM-DD HH:mm:ss");

                    this.setState({
                        dateSelected: {
                            "Start date": normalizedStart,
                            "End date": normalizedEnd
                        },
                        openDialogDateSelector: false,
                        reload: this.state.reload - 1
                    });
                }}
            />
            <Modal open={this.state.openDialogZoneSelector !== null}
                onClose={() => this.setState({ openDialogZoneSelector: null })}
                onValidate={() => {
                    this.setState({
                        zoneSelected: this.state.openDialogZoneSelector !== "all" ? this.state.openDialogZoneSelector : null,
                        callcenterSelected: null,
                        callCenterList: this.state.openDialogZoneSelector.secondaryList,
                        openDialogZoneSelector: null,
                        reload: this.state.reload - 1
                    });
                }}
                title={strings.Zone}
                icon={"arrowFrom"}
                fields={
                    this.state.openDialogZoneSelector ? [
                        {
                            type: "selectElement",
                            openTop: false,
                            adjustHeight: true,
                            placeholder: strings.AllZones,
                            elementsList: { results: this.state.zoneList },
                            selectedElementId: this.state.openDialogZoneSelector ? this.state.openDialogZoneSelector.id : null,
                            onSelectElement: (element) => {
                                if (element) {
                                    this.setState({ openDialogZoneSelector: element });
                                }
                                else {
                                    this.setState({ openDialogZoneSelector: "all" });
                                }
                            }
                        }
                    ] : null
                }
            />
            <Modal open={this.state.openDialogCallCenterSelector !== null}
                onClose={() => this.setState({ openDialogCallCenterSelector: null })}
                onValidate={() => {
                    this.setState({
                        callcenterSelected: this.state.openDialogCallCenterSelector.id ? this.state.openDialogCallCenterSelector : null,
                        openDialogCallCenterSelector: null,
                        reload: this.state.reload - 1
                    });
                }}
                title={strings.CallCenters}
                icon={"building"}
                fields={
                    this.state.openDialogCallCenterSelector ? [
                        {
                            type: "selectElement",
                            openTop: false,
                            adjustHeight: true,
                            placeholder: strings.allCallCenters,
                            elementsList: this.state.callCenterList ? { results: this.state.callCenterList } : this.props.monitoring.secondarycallcenters,
                            selectedElementId: this.state.openDialogCallCenterSelector && this.state.openDialogCallCenterSelector.id ? this.state.openDialogCallCenterSelector.id : null,
                            onSelectElement: (element) => {
                                this.setState({ openDialogCallCenterSelector: element ? element : "all" });
                            }
                        }
                    ] : null
                }
            />
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(DashboardContainer);
